import type { NarouDetailedMeta } from './types';

export function parseDetailedMetaFromDoc(doc: Document): NarouDetailedMeta {
  const meta: NarouDetailedMeta = {};

  const rows = doc.querySelectorAll('#noveltable1 tr, #noveltable2 tr, .noveltable tr');
  for (const row of rows) {
    const th = row.querySelector('th')?.textContent?.trim() || '';
    const td = row.querySelector('td')?.textContent?.trim() || '';

    if (th.includes('ジャンル')) {
      meta.genre = td;
    } else if (th.includes('キーワード')) {
      const keywords: string[] = [];
      for (const a of row.querySelectorAll('td a')) {
        const kw = a.textContent?.trim();
        if (kw) keywords.push(kw);
      }
      if (keywords.length === 0 && td) {
        meta.keywords = td.split(/\s+/).filter(Boolean);
      } else {
        meta.keywords = keywords;
      }
    } else if (th.includes('文字数')) {
      const numStr = td.replace(/[^0-9]/g, '');
      if (numStr) {
        meta.charCount = Number.parseInt(numStr, 10);
      }
    } else if (th.includes('掲載状況') || th.includes('連載状況')) {
      if (td.includes('完結済')) {
        meta.status = 'completed';
      } else if (td.includes('連載中')) {
        meta.status = 'ongoing';
      } else if (td.includes('短編')) {
        meta.status = 'short';
      }
    } else if (th.includes('小説タイプ') || th.includes('種別')) {
      if (td.includes('短編')) {
        meta.type = 'short';
      } else {
        meta.type = 'series';
      }
    }
  }

  if (!meta.status && meta.type === 'short') {
    meta.status = 'short';
  }

  return meta;
}
